import {PhotoStatusKeyEnum} from '../../../../../service/phototool/phototool-type';

export enum PhotoTabKeyEnum {
    All = 'all',
    Owner = 'owner',
    Customer = 'customer',
    Selected = 'selected',
    Video = 'video',
}

export enum PhotoFilterEnum {
    source = 'pht-owner',
    sourceIds = 'pht-sources',
    statuses = 'pht-statuses',
    tagIds = 'pht-tags',
    timeRange = 'pht-range',
}

type TimeRangeType = [Date | null, Date | null];

export type PhotoDrawerFilterType = Readonly<{
    [PhotoFilterEnum.sourceIds]: Array<number>;
    [PhotoFilterEnum.statuses]: Array<PhotoStatusKeyEnum>;
    [PhotoFilterEnum.tagIds]: Array<number>;
    [PhotoFilterEnum.timeRange]: TimeRangeType;
}>;

export type PhotoFilterType = Readonly<
    PhotoDrawerFilterType & {
        [PhotoFilterEnum.source]: PhotoTabKeyEnum;
    }
>;

export type UsePhotoFilterType = {
    filter: PhotoFilterType;
    setFilter: (filter: Partial<PhotoFilterType>) => void;
};
